import { StreamActions } from "@hotwired/turbo";

type Guess = {
	income_source_id: number | null;
	distribution_date: string | null;
};

// Fills the upload wizard's income source / distribution date fields with
// the guesses broadcast by FilenameGuessJob. Only ever fills blanks —
// anything the user has already set is left alone.
//
// Must be a regular function, not an arrow: Turbo binds `this` to the
// <turbo-stream> element that carries the payload.
StreamActions.prefill_guesses = function () {
	document.getElementById("guess-indicator")?.remove();

	const guesses: Record<string, Guess> = JSON.parse(
		this.templateElement.content.textContent ?? "{}",
	);

	for (const [filename, guess] of Object.entries(guesses)) {
		const entry = document.querySelector(
			`[data-guess-filename="${CSS.escape(filename)}"]`,
		);
		if (!entry) continue;

		const select = entry.querySelector<HTMLSelectElement>(
			'select[name="statements[][income_source_id]"]',
		);
		if (select && select.value === "" && guess.income_source_id != null) {
			select.value = String(guess.income_source_id);
			select.dispatchEvent(new Event("change", { bubbles: true }));
		}

		const date = entry.querySelector<HTMLInputElement>(
			'input[name="statements[][distribution_date]"]',
		);
		if (date && date.value === "" && guess.distribution_date) {
			date.value = guess.distribution_date;
		}
	}
};
